import React, { useEffect, useState } from "react";
import {
  getCurrentFY,
  getCurrentMonthFirstDate,
  getOnePreviousDate,
} from "../../../Utilitie";
import PDDController from "./PDDController";
import DayEntryGraph from "./PDDComps/DayEntryGraph";
import PDDMonthYearTable from "./PDDComps/PDDMonthYearTable";
import PDDMonthYearGraph from "./PDDComps/PDDMonthYearGraph";
import Loading from "../../../Extra/Loading";
import PDDSummaryGraph from "./PDDComps/PDDSummaryGraph";
import PDDSummaryTable from "./PDDComps/PDDSummaryTable";
import { useGlobalContext } from "../../../Context/GlobalContext";
const PDDMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [PDDComparisonData, setPDDComparisonData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(getOnePreviousDate());
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [fetchState, setFetchState] = useState(false);
  const [selectedFyYear, setSelectedFyYear] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [activeMetrics, setActiveMetrics] = useState(["total_trains_count"]);
  const [PDDSummaryData, setPDDSummaryData] = useState(null);
  const [loadingS, setLoadingS] = useState(false);
  const [errorS, setErrorS] = useState(false);
  const currentYear = getCurrentFY();
  const [year, setYear] = useState(currentYear.slice(0, 4));
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  ); // last 10 years
  const [PDDFilteredSummaryData, setPDDFilteredSummaryData] = useState(null);
  const [openStates, setOpenStates] = useState({
    "Financial Year": false,
    "Station Code": false,
    Month: false,
    Metrics: false,
  });

  const fetchData = async () => {
    setLoading(true);
    let url;
    // if (selectedDate) {
    url = `${urlPrefix}pddDateRange?start=${startDate}&end=${selectedDate}`;
    // } else {
    //   url = `${urlPrefix}pddDateRange?start=${}&end=${getOnePreviousDate()}`;
    // }
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.status === "ok") {
        setPDDComparisonData(data.data);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      setError(false);
    }
  };
  useEffect(() => {
    fetchData();
    // setDateForGlobal(date);
  }, [fetchState]);
  // //////////////////////////////////////////////////////////////////////////
  // ////////////////////////////FETCH SUMMERY/////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////
  const fetchDataSummary = async () => {
    setLoadingS(true);
    let url = `${urlPrefix}pdd/financial-month-wise?FyYear=${year}-${Number(year) + 1}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.status === "ok") {
        setPDDSummaryData(data.data);
      }

      setLoadingS(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingS(false);
      setErrorS(false);
    }
  };
  useEffect(() => {
    fetchDataSummary();
    // setDateForGlobal(date);
  }, [year]);
  const handleCloseDropDown = () => {
    setOpenStates({
      "Financial Year": false,
      "Station Code": false,
      Month: false,
      Metrics: false,
    });
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-8 ">
          <div
            className="newUiBodyNM"
            style={{ height: "100%", position: "relative" }}
          >
            <PDDMonthYearTable
              data={PDDComparisonData}
              setSelectedDate={setSelectedDate}
              setStartDate={setStartDate}
              startDate={startDate}
              selectedDate={selectedDate}
              setFetchState={setFetchState}
              fetchState={fetchState}
            />
            {loading && <Loading />}
          </div>
        </div>
        <div className="col-md-4 ">
          <div className="newUiBodyNM" style={{ height: "100%" }}>
            <PDDMonthYearGraph
              data={PDDComparisonData}
              selectedDate={selectedDate}
            />
          </div>
        </div>
      </div>
      <hr className="" />
      <div className="d-flex  justify-content-between bg-dark text-white">
        <h5 className=" p-1 m-1">PDD Summary</h5>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(0, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="sticky-controller">
        <PDDController
          year={year}
          data={PDDSummaryData}
          openStates={openStates}
          setOpenStates={setOpenStates}
          setActiveMetrics={setActiveMetrics}
          setPDDFilteredSummaryData={setPDDFilteredSummaryData}
        />
      </div>
      <div
        className=""
        style={{ zIndex: 1 }}
        onClick={() => handleCloseDropDown()}
      >
        <PDDSummaryGraph
          data={PDDFilteredSummaryData}
          keyName={[...activeMetrics]}
        />
      </div>
      <div onClick={() => handleCloseDropDown()}>
        {" "}
        <PDDSummaryTable data={PDDFilteredSummaryData} />
      </div>
    </div>
  );
};
export default PDDMaster;
